<template>
  <div class="detail">
    <div class="d bar back_left" @click="goBack">
      <p class="a_back">
        <van-icon name="arrow-left" color="#fff" size="28" />
      </p>
    </div>
    <div id="iframe-container">
      <iframe
        v-show="showIframe"
        :src="iframeSrc"
        scrolling="auto"
        frameborder="0"
        id="iframe"
      ></iframe>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Toast, Dialog } from "vant";
// getHtml
import { addForm, infoFieldForm, editForm } from "@/service/form";
import { getKey, encrypt, rsaUtil, getRadioValue, serverPublicKey } from "@/common/js";

export default {
  name: "infoDetail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    let genKeyPair = rsaUtil.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;

    const state = reactive({
      list: [],
      fieldInfo: {},
      showCalendar: false,
      iframeSrc: "",
      showIframe: false,
    });

    onMounted(async () => {
      const { type } = route.query;
      await init();
      window.addEventListener("message", (event) => {
        const msg = event.data;
        console.log("event.data--", event.data);
        let flag = true;
        if (msg.data) {
          const msgJSON = JSON.parse(msg.data);
          console.log("msgJSON", msgJSON);
          for (const item of msgJSON) {
            const { require, value = "", title = "", check = "" } = item;
            const tipsTitle = title.substr(0, title.length - 1);
            if (require == "true" && value == "") {
              Toast.fail(`请填写${tipsTitle}`);
              flag = false;
              break;
            }
            if (check != undefined && check != "") {
              const reg = new RegExp(check.substr(1, check.length - 2));
              if (!reg.test(item.value)) {
                Toast.fail(`请输入正确的${tipsTitle}`);
                flag = false;
                break;
              }
            }
          }
          if (flag) {
            onSubmit(msgJSON);
          }
        }
      });
      if (type == 2) {
        await getInfoFieldForm();
        await sendMessage();
      } else {
        state.showIframe = true;
      }
    });
    const getInfoFieldForm = async () => {
      const { id } = route.query;
      if (id) {
        const { code, data } = await infoFieldForm({ fid: id });
        console.log("fieldInfo data", data);
        if (code === 10000 && data) {
          state.fieldInfo = data;
        }
      }
    };
    const sendMessage = () => {
      const { fieldInfo } = state;
      const iframeWin = document.getElementById("iframe").contentWindow;
      let ifData = {
        type: "",
        data: {},
      };
      if (fieldInfo.list.length > 0) {
        for (const item of fieldInfo.list) {
          ifData.data[item.fieldCode] = item.value;
        }
      }
      setTimeout(() => {
        iframeWin.postMessage(JSON.stringify(ifData), "*");
        state.showIframe = true;
      }, 1000);
    };
    // http://sxddata.k618.cn/static/diyform/sxd/apply.html
    const init = async () => {
      Toast.loading({
        message: "加载中",
      });
      const { url } = route.query;
      state.iframeSrc = url;
      // state.iframeSrc = "http://sxddata.k618.cn/static/diyform/sxd/apply.html";
      Toast.clear();
    };
    const edit = async (values) => {
      const { fieldInfo } = state;
      let arr = [];
      const { id } = route.query;
      let data = {
        id: fieldInfo.id,
        formId: id,
        list: [],
      };

      for (const item of values) {
        let obj = {
          fieldCode: item.name,
          value: item.value,
        };
        arr.push(obj);
      }
      data.list = arr;
      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      const res = await editForm(param);
      if (res.code === 10000) {
        // Dialog.alert({
        //   message:
        //     "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
        // }).then(() => {
        goTo();
        // });
      }
    };
    const add = async (values) => {
      let arr = [];
      const { id } = route.query;
      let data = {
        formId: id,
        list: [],
      };
      for (const item of values) {
        let obj = {
          fieldCode: item.name,
          value: item.value,
        };
        arr.push(obj);
      }
      data.list = arr;
      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      const res = await addForm(param);
      if (res.code === 10000) {
        // Dialog.alert({
        //   message:
        //     "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
        // }).then(() => {
        goTo();
        // });
      }
    };
    const goTo = () => {
      const { id, url } = route.query;
      if (id) {
        router.push({ path: "/info/detail", query: { id, url } });
      }
    };

    const onSubmit = async (values) => {
      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(() => {
          const { type = 1 } = route.query;
          // type: 2 修改
          if (type == 2) {
            edit(values);
          } else {
            add(values);
          }
        })
        .catch(() => {
          // on cancel
        });
    };
    const goBack = () => {
      router.push({ path: "/info/list" });
    };
    return {
      ...toRefs(state),
      onSubmit,
      getRadioValue,
      goBack,
    };
  },
  components: {},
};
</script>

<style lang="less" scoped>
@import "../../../common/style/mixin";
.detail {
  height: 100%;
  &-footer {
    padding: 0 30px;
    color: @primary;
    font-size: 16px;
    background: #fff;
  }
}
#iframe-container {
  height: 100%;
  width: 100%;
}
#iframe-container iframe {
  height: 100%;
  width: 100%;
}
.back_left {
  position: absolute;
  margin-top: 5px;
}
</style>
